import * as emailSignGenTypes from "../../types/admin/emailSignGenTypes";
//CREATE_EMAIL_SIGNATURE
export const createEmailSignatureReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case emailSignGenTypes.CREATE_EMAIL_SIGNATURE_REQUEST:
      return {
        ...state,
        createEmailSignatureLoading: true,
      };
    case emailSignGenTypes.CREATE_EMAIL_SIGNATURE_SUCCESS:
      return {
        ...state,
        createEmailSignatureLoading: false,
        createEmailSignatureList: payload,
        error: "",
      };
    case emailSignGenTypes.CREATE_EMAIL_SIGNATURE_FAIL:
      return {
        ...state,
        createEmailSignatureLoading: false,
        createEmailSignatureList: [],
      };
    default:
      return state;
  }
};
//UPDATE_EMAIL_SIGNATURE
export const updateEmailSignatureReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case emailSignGenTypes.UPDATE_EMAIL_SIGNATURE_REQUEST:
      return {
        ...state,
        updateEmailSignatureLoading: true,
      };
    case emailSignGenTypes.UPDATE_EMAIL_SIGNATURE_SUCCESS:
      return {
        ...state,
        updateEmailSignatureLoading: false,
        updateEmailSignatureList: payload,
        error: "",
      };
    case emailSignGenTypes.UPDATE_EMAIL_SIGNATURE_FAIL:
      return {
        ...state,
        updateEmailSignatureLoading: false,
        updateEmailSignatureList: [],
      };
    default:
      return state;
  }
};
//GET_ALL_EMAIL_SIGNATURE
export const getAllEmailSignatureReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case emailSignGenTypes.GET_ALL_EMAIL_SIGNATURE_REQUEST:
      return {
        ...state,
        EmailSignatureLoading: true,
      };
    case emailSignGenTypes.GET_ALL_EMAIL_SIGNATURE_SUCCESS:
      return {
        ...state,
        EmailSignatureLoading: false,
        EmailSignatureList: payload,
        error: "",
      };
    case emailSignGenTypes.GET_ALL_EMAIL_SIGNATURE_FAIL:
      return {
        ...state,
        EmailSignatureLoading: false,
        EmailSignatureList: [],
      };
    default:
      return state;
  }
};
//DELETE_EMAIL_SIGNATURE
export const deleteEmailSignatureReducer = (state = {}, action) => {
  const { type, payload } = action;
  switch (type) {
    case emailSignGenTypes.DELETE_EMAIL_SIGNATURE_REQUEST:
      return {
        ...state,
        deleteEmailSignatureLoading: true,
      };
    case emailSignGenTypes.DELETE_EMAIL_SIGNATURE_SUCCESS:
      return {
        ...state,
        deleteEmailSignatureLoading: false,
        deleteEmailSignatureList: payload,
        error: "",
      };
    case emailSignGenTypes.DELETE_EMAIL_SIGNATURE_FAIL:
      return {
        ...state,
        deleteEmailSignatureLoading: false,
        statusesTemplatesList: [],
      };
    default:
      return state;
  }
};
